<template>
  <section>
    <pb-drawer :title="$t('Gattaran_Feedback__WUQR' /** 我的反馈 */)" :visible.sync="viewOpen" :wrapper-closable="false" size="480px">
      <div class="list-wrap">
        <!-- Loading -->
        <div v-if="isLoading" v-loading="isLoading" :element-loading-text="$t('Gattaran_MSGCenter__PuUe' /** 正在加载中...*/)" class="loading-more" style="margin-top: 60%" />
        <section v-else>
          <div v-infinite-scroll="load" :infinite-scroll-disabled="isDisabled">
            <div v-if="lists.length === 0" class="content-empty">
              <img :src="require('../assets/empty.svg')" alt="" />
              <p>{{ $t('Gattaran_MSGCenter__wEBm' /** 暂无消息*/) }}</p>
            </div>
            <div v-for="(item, idx) in lists" :key="idx" class="card-wrap" @click="openDetail(item)">
              <!-- Card 头部 -->
              <div class="card-header">
                <span class="card-header-date">{{ item.statusUpdateAt }} |</span>
                <span class="card-header-name"> {{ item.chargeUser }}</span>
                <!-- <div> -->
                <pb-tag class="card-header-status" :type="getType(item)">
                  {{ item.currentStatus }}
                </pb-tag>
                <!-- </div> -->
              </div>
              <!-- Card所属模块 -->
              <div class="card-module">{{ getModule(item) }}</div>
              <!-- Card内容 -->
              <div class="card-content" style="-webkit-box-orient: vertical">
                <span>{{ item.description }}</span>
              </div>
            </div>
            <!-- 正在加载中 -->
            <div v-if="loadMore" v-loading="loadMore" :element-loading-text="$t('Gattaran_MSGCenter__PuUe' /** 正在加载中...*/)" class="loading-more" />
            <!-- 无更多消息 -->
            <div v-if="noMore" class="no-more">
              {{ noMoreTxt }}
            </div>
          </div>
        </section>
      </div>

      <!-- Footer -->
      <div class="feedback-footer">
        <div class="feedback-footer-btn" @click="openSend">
          <span>{{ $t('Gattaran_Feedback__RCjf' /** 创建新的问题反馈 */) }}</span>
        </div>
      </div>
      <!-- Card详情 -->
      <CardDetail ref="card-detail" :data="detail" />
    </pb-drawer>
    <!-- 发送记录 -->
    <Send ref="send" />
  </section>
</template>

<script>
import CardDetail from '../components/card-detail.vue';
import Send from './send.vue';
import _ from 'lodash';
import { API } from '../services';
export default {
  components: {
    Send,
    CardDetail,
  },
  data() {
    return {
      viewOpen: false,
      isLoading: false,
      isShow: false,
      loadMore: false,
      noMore: false,
      noMoreTxt: '',
      page: 1,
      pageSize: 10,
      flag: true,
      detail: {},
      lists: [],
    };
  },
  computed: {
    isDisabled() {
      return this.noMore || this.loadMore;
    },
  },
  watch: {
    viewOpen: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.resetInfiniteScroll();
        }
      },
    },
  },
  methods: {
    getList() {
      API()
        .getFeedbackList({
          page: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          // 加载更多关闭
          this.loadMore = false;
          this.lists = this.lists.concat(res.lists);
          // 如果数组和total相等，没有更多了
          if (this.lists.length === res.total) {
            this.noMore = true;
            // 总条数是否大于10条，控制展示文案
            this.noMoreTxt = res.total > 10 ? this.$t('Gattaran_MSGCenter__chmB' /** 无更多消息 */) : '';
          }
          // 我的反馈loading结束
          this.isLoading = false;
        });
    },
    getType(item) {
      const status = _.get(item, 'status', 1);
      switch (status) {
        case 1:
          return 'info';
        case 2:
          return 'warning';
        case 3:
          return 'success';
      }
    },
    getModule(item) {
      const module = _.get(item, 'module', '');
      return module.split('>')[module.split('>').length - 1];
    },
    load() {
      // 加载更多开启
      this.loadMore = true;
      this.getList({
        page: this.page++,
        pageSize: 10,
      });
    },
    openDetail(item) {
      // 反馈详情打开
      this.$refs['card-detail'].open = true;
      // 处理进度loading
      this.$refs['card-detail'].isFlowLoading = true;
      // 反馈信息loading
      this.$refs['card-detail'].isInfoLoading = true;
      API()
        .getFeedbackDetail({
          feedbackId: item.feedbackId,
        })
        .then((res) => {
          this.detail = res;
          // 处理进度loading结束
          this.$refs['card-detail'].isFlowLoading = false;
          // 反馈信息loading结束
          this.$refs['card-detail'].isInfoLoading = false;
        });
    },
    openSend() {
      this.viewOpen = false;
      setTimeout(() => {
        // 发送反馈窗口打开
        this.$refs.send.sendOpen = true;
      }, 300);
    },
    resetInfiniteScroll() {
      this.page = 1;
      // 我的反馈loading开始
      this.isLoading = true;
      this.lists = [];
      // 加载更多开关关闭
      this.loadMore = false;
      // 没有更多内容开关关闭
      this.noMore = false;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.list-wrap {
  margin-bottom: 84px;
}
.card-wrap {
  margin: 16px;
  padding: 16px;
  margin: 8px;
  border-radius: 4px;
  cursor: pointer;
}
.card-wrap:hover {
  background: #f8f8fa;
}
.card-header {
  font-family: DiDiSans-Pro-Thin;
  font-size: 12px;
  color: #595c66;
  text-align: left;
  line-height: 20px;
  font-weight: normal;
}
.card-header-status {
  float: right;
}
.card-module {
  margin-top: 8px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #282b33;
  line-height: 22px;
  font-weight: 600;
}
.card-content {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  margin-top: 3px;
  font-size: 14px;
  color: #8d9099;
  line-height: 20px;
  word-break: break-word;
  white-space: pre-wrap;
}
.feedback-footer {
  width: 480px;
  height: 64px;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  border-top: 1px solid #e9eaee;
  z-index: 999;
}
.feedback-footer-btn {
  background: rgba(255, 255, 255, 0);
  padding: 5px 16px;
  border-radius: 4px;
  position: absolute;
  bottom: 16px;
  right: 16px;
  cursor: pointer;
}
.feedback-footer-btn span {
  font-family: DiDiSans-Pro-Medium;
  font-size: 14px;
  color: #f76a31;
  line-height: 22px;
  font-weight: normal;
}
.loading-more {
  width: 100%;
  height: 74px;
}
.content-empty {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #8d9099;
  text-align: center;
  padding-top: calc(50vh - 140px);
}
.no-more {
  box-sizing: border-box;
  font-size: 14px;
  color: #8d9099;
  text-align: center;
  padding-top: 16px;
  height: 74px;
  font-weight: 400;
}
:deep(.pb-drawer__header) {
  height: 56px;
  margin-bottom: 0;
  border-bottom: 1px solid #e9eaee;
  box-sizing: border-box;
  padding: 16px 12px 16px 16px;
  font-family: DiDiSans-Pro-Medium;
  font-size: 16px;
  color: #282b33;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}
:deep(.pb-drawer__body) {
  padding: 0 !important;
}
</style>
